import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ZoneButton from './ZoneButton';
import ZoneButtonsWrapper from './ZoneButtonsWrapper';

const ButtonAB = styled(ZoneButton)`
  margin-top: 11%;
  width: 36%;
`;

const ButtonABC = styled(ZoneButton)`
  width: 53%;
`;

const ButtonABCD = styled(ZoneButton)`
  width: 71%;
`;

const ZoneButtonsA = ({ onClickZoneAB, onClickZoneABC, onClickZoneABCD }) => (
  <ZoneButtonsWrapper>
    <ButtonAB onClick={onClickZoneAB} />
    <ButtonABC onClick={onClickZoneABC} />
    <ButtonABCD onClick={onClickZoneABCD} />
  </ZoneButtonsWrapper>
);

ZoneButtonsA.propTypes = {
  onClickZoneAB: PropTypes.func.isRequired,
  onClickZoneABC: PropTypes.func.isRequired,
  onClickZoneABCD: PropTypes.func.isRequired,
};

export default ZoneButtonsA;
